import { defineMessages } from 'react-intl';

export const messages = {
  details: defineMessages({
    resourceInfo: {
      id: 'manage-services.resources.details.resource-info',
      defaultMessage: 'Equipment info',
    },
    placeholder: {
      id: 'manage-services.resources.details.placeholder',
      defaultMessage: 'Select an equipment to see more details',
    },
    editResource: {
      id: 'manage-services.resources.details.edit-resource',
      defaultMessage: 'Edit',
    },
    deleteResource: {
      id: 'manage-services.resources.details.delete-resource',
      defaultMessage: 'Delete Equipment',
    },
    missingObjectsTitle: {
      id: 'manage-services.resources.details.missing-objects-title',
      defaultMessage: 'Missing Services',
    },
    missingObjectsCopy: {
      id: 'manage-services.resources.details.missing-objects-copy',
      defaultMessage: 'Associate at least one service to make this equipment bookable.',
    },
  }),
  list: defineMessages({
    servicesCount: {
      id: 'manage-services.resources.list.services-count',
      defaultMessage: '{servicesCount, plural, one {# service} other {# services}}',
    },
    disabledTooltip: {
      id: 'manage-services.resources.list.disabled-tooltip',
      defaultMessage: 'Equipment must be associated with services to be bookable by members.',
    },
  }),
  deleteModal: defineMessages({
    title: {
      id: 'manage-services.resources.delete-modal.title',
      defaultMessage: 'Delete equipment',
    },
    description: {
      id: 'manage-services.resources.delete-modal.description',
      defaultMessage:
        'Are you sure you want to delete this equipment? Existing reservations will not be canceled. Please cancel reservations directly in the “Appointments” tab.',
    },
    cancel: {
      id: 'manage-services.resources.delete-modal.cancel',
      defaultMessage: 'Cancel',
    },
    confirm: {
      id: 'manage-services.resources.delete-modal.confirm',
      defaultMessage: 'Confirm',
    },
  }),
  form: defineMessages({
    addResource: {
      id: 'manage-services.resources.form.add-resource',
      defaultMessage: 'Add equipment',
    },
    editResource: {
      id: 'manage-services.resources.form.edit-resource',
      defaultMessage: 'Edit {resourceName}',
    },
    delete: {
      id: 'manage-services.resources.form.delete',
      defaultMessage: 'Delete equipment',
    },
    name: {
      id: 'manage-services.resources.form.name',
      defaultMessage: 'Name',
    },
    namePlaceholder: {
      id: 'manage-services.resources.form.name-placeholder',
      defaultMessage: 'Room 1',
    },
    cancel: {
      id: 'manage-services.resources.form.cancel',
      defaultMessage: 'Cancel',
    },
    save: {
      id: 'manage-services.resources.form.save',
      defaultMessage: 'Save',
    },
    labelInfo: {
      id: 'manage-services.resources.form.label-info',
      defaultMessage: 'Equipment details',
    },
    serviceHint: {
      id: 'manage-services.resources.form.service-hint',
      defaultMessage: 'In order for users to make a reservation, equipment must be associated with a Service.',
    },
  }),
  validator: defineMessages({
    fieldRequired: {
      id: 'manage-services.resources.form.validator.field-required',
      defaultMessage: 'This field is required',
    },
    invalidEmail: {
      id: 'manage-services.resources.form.validator.invalid-email',
      defaultMessage: 'Please enter a valid email address',
    },
    invalidPhone: {
      id: 'manage-services.resources.form.validator.invalid-phone',
      defaultMessage: 'Please enter a valid phone number',
    },
    startTimeAfterEndTime: {
      id: 'manage-services.resources.form.validator.validator.start-time-after-end-time',
      defaultMessage: 'Start time cannot be later than end time',
    },
  }),
  success: defineMessages({
    resourceCreated: {
      id: 'manage-services.resources.success.resource-created',
      defaultMessage: 'Equipment was successfully added.',
    },
    resourceEdited: {
      id: 'manage-services.resources.success.resource-edited',
      defaultMessage: 'Equipment was successfully edited.',
    },
    resourceDeleted: {
      id: 'manage-services.resources.success.resource-deleted',
      defaultMessage: 'Equipment was successfully deleted.',
    },
  }),
  error: defineMessages({
    problemWithRequest: {
      id: 'manage-services.resources.error.problem-with-request',
      defaultMessage: 'There was a problem with your request.',
    },
  }),
  empty: defineMessages({
    header: {
      id: 'manage-services.resources.empty.header',
      defaultMessage: 'No equipment added yet',
    },
    subheader: {
      id: 'manage-services.resources.empty.subheader',
      defaultMessage: 'Start now by adding equipment name and availability',
    },
    button: {
      id: 'manage-services.resources.empty.button',
      defaultMessage: 'Add equipment',
    },
    emptyIcon: {
      id: 'manage-services.resources.empty.empty-icon',
      defaultMessage: 'Empty equipment icon',
    },
  }),
};
